import { type FC, type ReactNode, type MouseEvent } from 'react';
import classnames from 'classnames';
import { Link } from 'dibs-elements/exports/Link';

import styles from './SharedPaginationPageItem.scss';
import dibsCss from 'dibs-css';

type Props = {
    children: ReactNode;
    href?: string;
    isSelected: boolean;
    onClick: (e: MouseEvent<HTMLElement>) => void;
    dataTn?: string;
};

export const SharedPaginationPageItem: FC<Props> = ({
    children,
    href,
    isSelected,
    onClick,
    dataTn,
}) => {
    const itemClassName = classnames(styles.item, dibsCss.block, dibsCss.wFull, dibsCss.textCenter);
    return isSelected ? (
        <span className={classnames(itemClassName, dibsCss.bgMoonstone)} data-tn={dataTn}>
            {children}
        </span>
    ) : (
        <Link href={href} className={itemClassName} dataTn={dataTn} onClick={onClick}>
            {children}
        </Link>
    );
};
